module.exports = __webpack_public_path__ + "static/media/double-chevron-down.36481e99.svg";